/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function BlockElementIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "block-element", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M5 19.5H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5 5.5H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("rect", { x: 6.5, y: 8.5, width: 12, height: 8, stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(BlockElementIcon);
export default ForwardRef;
//# sourceMappingURL=blockElementIcon.js.map